import { EUserStatus } from 'models/user.model'
import { GROUPS } from './enums/userGroup'
import { TCognitoUserInfo } from 'models/cognito.model'

type GetUserRoleParams = {
  cognitoUser: TCognitoUserInfo
  groups: string[]
}

const getUserRole = ({ cognitoUser, groups }: GetUserRoleParams): EUserStatus => {
  if (cognitoUser['custom:company'] === 'individualPlan') {
    return EUserStatus.USER_B2C
  }
  if (groups.includes(GROUPS.ADMIN)) {
    return EUserStatus.ADMIN
  }
  if (groups.includes(GROUPS.COMPANY_OWNER)) {
    return EUserStatus.ADMIN
  }
  if (groups.includes(GROUPS.MANAGER)) {
    return EUserStatus.ADMIN
  }
  return EUserStatus.EMPLOYEE
}

export { getUserRole }
